'use client'

import { useBIPageView } from '@/context/BISdkContext'
import { PropsWithChildren } from 'react'

export default function CreatorsPageWrapper({ children }: PropsWithChildren) {
  useBIPageView()

  return <main className="flex h-full flex-col gap-8 px-6 py-4 md:gap-10 md:py-10">{children}</main>
}
